import script from "./XPageHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./XPageHeader.vue?vue&type=script&lang=ts&setup=true"

import "./XPageHeader.vue?vue&type=style&index=0&id=2e97c7c7&lang=scss"

const __exports__ = script;

export default __exports__